import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useLangContext } from "../../context/langContext";

import UsersTableComponent from "../../components/panel/users/UsersTable";

const compInfos = {
  en: {
    title: "Contacts",
    subtitle: "Your Contacts list",
    buttonOne: "upload phone's file",
  },
  fa: {
    subtitle: "لیست کابران",
    title: "کاربران ",
    buttonOne: "ایجاد کاربر جدید",
  },
};

export default function UsersPage() {
  const { lang } = useLangContext();

  const infos = compInfos[lang];
  const [walletReload, setWalletReload] = useState<boolean>(false);

  return (
    <>
      <Stack
        width="100%"
        direction="column"
        justifyContent="start"
        alignItems="start"
        px={{ xs: "6px", md: "20px" }}
        gap="10px"
      >
        <Stack direction={"column"} width="100%">
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems={{ md: "center", xs: "start" }}
            width="100%"
          >
            <Stack>
              <Typography
                variant="h4DemiBold"
                color={(theme) => theme.palette.dominant.main}
                sx={{
                  mb: "4px",
                  mt: { xs: "0px", sm: "24px" },
                }}
              >
                {infos.title}
              </Typography>
              <Typography
                variant="footerDemiBold"
                sx={{
                  mb: "20px",
                  color: ({ palette }) => palette.complement[300],
                }}
              >
                {infos.subtitle}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ md: "space-between", xs: "center" }}
              width={{ xs: "100%", sm: "initial" }}
              gap="12px"
            ></Stack>
          </Stack>
        </Stack>
        <UsersTableComponent
          walletReload={walletReload}
          setWalletReload={setWalletReload}
        />
      </Stack>
    </>
  );
}
